<template>
  <!-- Car Rental Slider -->
  <section class="car-rental-slider-section aos" data-aos="fade-up">
    <div class="car-rental-carousel">
      <div class="car-rental-slider owl-carousel owl-theme owl-loaded owl-drag">
        <Carousel
          :wrap-around="true"
          :settings="settings"
          :breakpoints="breakpoints"
        >
          <Slide v-for="item in IndexSixCar" :key="item.id">
            <div class="car-rental-slider-item">
              <img
                :src="require(`@/assets/img/${item.image}`)"
                class="img-fluid"
                alt=""
              />
              <div class="container">
                <div class="car-rental-carousel-content">
                  <h6>{{ item.title }}</h6>
                  <h3 class="aos" data-aos="fade-up" data-aos-delay="200">
                    {{ item.text }}
                  </h3>
                  <h5 class="aos" data-aos="fade-up" data-aos-delay="300">
                    <span>{{ item.amount }}</span
                    >/ Month
                  </h5>
                  <p class="aos" data-aos="fade-up" data-aos-delay="400">
                    {{ item.content }}<br />taxes, title and fees extra
                  </p>
                  <router-link to="contact">{{ item.mode }}</router-link>
                </div>
              </div>
            </div>
          </Slide>
          <template #addons>
            <Navigation />
          </template>
        </Carousel>
      </div>
    </div>
  </section>
  <!-- /Car Rental Slider -->
</template>
<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import IndexSixFeatured from "@/assets/json/indexSixFeatured.json";
import IndexSixCar from "@/assets/json/indexSixCar.json";
export default {
  data() {
    return {
      IndexSixFeatured: IndexSixFeatured,
      IndexSixCar: IndexSixCar,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 991 and up
        991: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 1,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
};
</script>
